import PropTypes from "prop-types";
import { RadioSegments } from "@/components/ui/radio-segments";
import FieldError from "./FieldError";
import SettingsSection from "./SettingsSection";
import { fieldId, PRIORITY_OPTIONS } from "./settingsForm";
import { MUSCLES, REGIONS } from "../lib/format";

const MEANINGS = [
  {
    term: "Emphasize",
    text: "up to +3 sets a week instead of +2 when it recovers well, and sessions that train it score higher. Never adds work on a bad day.",
  },
  {
    term: "Grow",
    text: "(the default) up to +2 sets a week when it has recovered and you beat last time.",
  },
  {
    term: "Maintain",
    text: "holds at the fewest sets that keep it (maintenance volume), and sessions lean away from it.",
  },
];

/** Per muscle: emphasize / grow / maintain, grouped by body region. */
function PrioritiesSection({ priorities, onChange, errorFor }) {
  return (
    <SettingsSection
      id="training-settings-priorities"
      title="Priorities"
      error={errorFor("priorities") || undefined}
      description={
        <dl className="m-0 flex flex-col gap-1">
          {MEANINGS.map(({ term, text }) => (
            <div key={term}>
              <dt className="inline font-medium text-foreground">{term}:</dt>{" "}
              <dd className="m-0 inline">{text}</dd>
            </div>
          ))}
        </dl>
      }
    >
      {REGIONS.map((region) => {
        const muscles = MUSCLES.filter((m) => m.region === region.code);
        if (muscles.length === 0) return null;
        return (
          <div key={region.code} className="flex flex-col gap-2">
            <h3 className="m-0 text-xs font-semibold tracking-wide text-muted-foreground uppercase">
              {region.label}
            </h3>
            <div className="grid gap-3 sm:grid-cols-2">
              {muscles.map((muscle) => (
                <div key={muscle.code} className="flex flex-col gap-1">
                  <RadioSegments
                    legend={muscle.label}
                    options={PRIORITY_OPTIONS}
                    value={priorities[muscle.code]}
                    onChange={(value) => onChange({ ...priorities, [muscle.code]: value })}
                  />
                  <FieldError id={`${fieldId(`priorities.${muscle.code}`)}-error`}>
                    {errorFor(`priorities.${muscle.code}`)}
                  </FieldError>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </SettingsSection>
  );
}

PrioritiesSection.propTypes = {
  priorities: PropTypes.objectOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  errorFor: PropTypes.func.isRequired,
};

export default PrioritiesSection;
